import { renderInline } from "./inline-renderer.js";
import { resolveInlineConfig } from "../shared/config.js";

import type { FormVueInlineOptions } from "../shared/schema-types.js";

const FormVue = {
  button(target: string | HTMLElement, options: FormVueInlineOptions): void {
    const el = typeof target === "string" ? document.querySelector<HTMLElement>(target) : target;
    if (!el) { console.error(`FormVue: target element not found: ${target}`); return; }
    if (!options.formId) { console.error("FormVue: formId is required"); return; }
    if (el.shadowRoot) this.destroy(el);

    const config = resolveInlineConfig(options);
    renderInline(el, config);
  },

  destroy(target: string | HTMLElement): void {
    const el = typeof target === "string" ? document.querySelector<HTMLElement>(target) : target;
    if (!el) return;
    (el as any).__fvUnmount?.();
    delete (el as any).__fvUnmount;
    if (el.shadowRoot) el.shadowRoot.innerHTML = "";
    el.style.removeProperty("display");
    el.style.removeProperty("width");
  },

  update(target: string | HTMLElement, options: FormVueInlineOptions): void {
    this.destroy(target);
    this.button(target, options);
  },
};

export { FormVue };
export type { FormVueInlineOptions } from "../shared/schema-types.js";
export type { InlineConfig, EmbedContext } from "../shared/types.js";
